// staff
(function () {
    'use strict';
    const moreStaffBtn = document.querySelector('.view-more-staff')
    const moreStaffCont = document.querySelector('.more-staff')
    
    if (moreStaffBtn && moreStaffCont) {
        const className = 'open';
        const moreStaffBtnInner = moreStaffBtn.querySelector('.inner');

        const moreStaffContInner = moreStaffCont.querySelector('.inner');
        const moreStaffBtnInnerr_html = moreStaffBtnInner.innerHTML;
        const closeMessage = 'VIEW LESS -';

        moreStaffBtn.addEventListener('click', function () {
            
            const moreStaffContInner_h = moreStaffContInner.offsetHeight;

            if (hasClass(moreStaffCont, className)) {
                removeClass(moreStaffCont, className);
                moreStaffCont.style.height = '0';
                moreStaffBtnInner.innerHTML = moreStaffBtnInnerr_html;
            } else {
                addClass(moreStaffCont, className);
                moreStaffCont.style.height = moreStaffContInner_h + 'px';
                moreStaffBtnInner.innerHTML = closeMessage;
            }
            
        });
    }

    // http://youmightnotneedjquery.com/
    function hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        } else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        }
    }

    function addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            var current = el.className, found = false;
            var all = current.split(' ');
            for (var i = 0; i < all.length, !found; i++) found = all[i] === className;
            if (!found) {
                if (current === '') el.className = className;
                else el.className += ' ' + className;
            }
        }
    }

    function removeClass(el, className) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');

    }
}());